import { createSelector } from 'reselect'

import questionStatus from 'helpers/enums/creationTool/questionStatus'

const mcqPendingRequestsSelector = createSelector(
	[ state => state.creationTool.mcq ],
	mcqState => mcqState.question.status !== questionStatus.NONE
)

export default mcqPendingRequestsSelector
